import React from "react"

const ChangeStyleContext = React.createContext(false); 

export default ChangeStyleContext;  